import { HeartStraight, MapPin, Prohibit } from '@phosphor-icons/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ProductCardBaseProps } from '.';
import BulletSeparatedList from '../BulletSeparatedList';
import { SrOnly } from '../SrOnly';
import {
  Body,
  Image,
  Location,
  Media,
  SaveButton,
  Seller,
  StaticTitle,
  Status,
  StatusBadge,
  Wrapper,
} from './wrapper';

const ProductCardRemoved = ({
  title,
  image,
  location,
  sellerName,
  uspList,
  save,
  testId,
}: ProductCardBaseProps) => {
  const { t } = useTranslation(['search', 'other']);

  const saveButtonTitle = save?.isSaved
    ? t('removeSavedAd', { ns: 'other' })
    : t('saveAd', { ns: 'other' });

  return (
    <Wrapper $isRemoved data-testid={testId}>
      <Body>
        <Media>
          <picture>
            {image.webp && (
              <source
                type="image/webp"
                srcSet={image.webp.map((webp) => `${webp.url} ${webp.width}w`).join(', ')}
                sizes={image.sizes}
              />
            )}
            {image.srcSet ? (
              <Image
                srcSet={image.srcSet.map((srcSet) => `${srcSet.url} ${srcSet.width}w`).join(', ')}
                sizes={image.sizes}
                src={image.src}
                alt={title}
              />
            ) : (
              <Image src={image.src} alt={title} />
            )}
          </picture>
          {save && (
            <SaveButton onClick={save.onClick} title={saveButtonTitle}>
              <HeartStraight size="1em" weight={save.isSaved ? 'fill' : 'bold'} />
              <SrOnly>{saveButtonTitle}</SrOnly>
            </SaveButton>
          )}
        </Media>
        <Status>
          <Location>
            <MapPin size={14} weight="bold" /> {location}
          </Location>
          <StatusBadge $tone="negative" $size="small">
            {t('vehicleStatus.removed', { ns: 'other' })}
            <Prohibit size={16} weight="bold" />
          </StatusBadge>
        </Status>
        <Seller>{sellerName}</Seller>
        <StaticTitle>{title}</StaticTitle>
        {uspList && <BulletSeparatedList items={uspList} size="small" tone="alt" />}
      </Body>
    </Wrapper>
  );
};

export default ProductCardRemoved;
